import type { ColumnDef } from "@tanstack/react-table";
import { Stack } from "@/core/components/ui/stack";
import type { ApReceipt } from "@/accounts-payable/types";
import { cn } from "@/core/utils/utils";

export const vendorCol: ColumnDef<ApReceipt> = {
  id: "vendor",
  header: "Store",
  accessorFn: (row) => row.vendor_name,
  meta: { size: "240px" },
  cell: ({ row }) => (
    <Stack gap="xs">
      <span className="font-medium">{row.original.vendor_name}</span>
      <span
        className={cn("text-sm text-tertiary-text", {
          italic: !row.original.po_number,
        })}
      >
        {row.original.po_number
          ? `PO / job: ${row.original.po_number}`
          : "No PO or job name"}
      </span>
    </Stack>
  ),
};
